import React from "react";
import { ProcessorsEnum } from "../../shared/constants/ProcessorEnum";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import { CheckoutTransferETPay } from "../CheckoutTransferETPay/CheckoutTransferETPay";
import { CheckoutTransferPse } from "../CheckoutTransferPse/CheckoutTransferPse";
import { CheckoutTransferSTP } from "../CheckoutTransferSTP/CheckoutTransferSTP";
import { CheckoutTransferSafetyPay } from "../CheckoutTransferSafetypay/CheckoutTransferSafetypay";
export var CheckoutTransfer = function () {
    var transferProcessor = useCheckoutContext().transferProcessor;
    var renderTransferSection = function () {
        switch (transferProcessor) {
            case ProcessorsEnum.STP:
                return React.createElement(CheckoutTransferSTP, null);
            case ProcessorsEnum.SAFETY_PAY_TRANSFER:
                return React.createElement(CheckoutTransferSafetyPay, null);
            case ProcessorsEnum.SAFETY_PAY_TRANSFER_PROCESSOR:
                return React.createElement(CheckoutTransferSafetyPay, null);
            case ProcessorsEnum.PSE:
                return React.createElement(CheckoutTransferPse, null);
            case ProcessorsEnum.ETPAY:
                return React.createElement(CheckoutTransferETPay, null);
            case ProcessorsEnum.ETPAYPLUS:
                return React.createElement(CheckoutTransferETPay, null);
            default:
                return React.createElement("div", null);
        }
    };
    return React.createElement(React.Fragment, null, renderTransferSection());
};
